export default "__VITE_ASSET__BNPGxY98__"